import { render } from "./ContactDashboard.vue?vue&type=template&id=03ed6f2e"
import script from "./ContactDashboard.vue?vue&type=script&lang=js"
export * from "./ContactDashboard.vue?vue&type=script&lang=js"

import "./ContactDashboard.vue?vue&type=style&index=0&id=03ed6f2e&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__